<template>
  <megabit-base-dialog :show-dialog="true" :width="600">
    <template v-slot:body>
      <v-sheet v-if="isLoading" class="pa-3" dark>
        <v-skeleton-loader
          class="mx-auto"
          :max-width="600"
          max-height="768"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>
      <v-card dark v-else>
        <v-card-title class="align-self-center">
          <span class="text-h6 white--text"
            >{{
              $t('title-forms.cadastro', { nome: $t('menu-home.delivery') })
            }}
            (alt+r)</span
          >
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row dense>
              <v-col cols="4" md="3" lg="2">
                <c-input
                  :label="$t('labels.codigo')"
                  :placeholder="$t('labels.codigo')"
                  type="number"
                  v-model="form.codigo"
                  :readonly="true"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="8">
                <c-input
                  :label="$t('labels.descricao')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.descricao') })
                  "
                  :maxLength="40"
                  :minLength="3"
                  :isRequired="true"
                  v-model="form.descricao"
                />
                <v-switch
                  v-model="form.isExterior"
                  label="Entrega Exterior"
                  :color="form.isExterior ? 'success' : ''"
                  @change="setDefaultDistance"
                >
                </v-switch>
                <v-switch
                  v-model="form.qualquerDistancia"
                  label="Qualquer distância"
                  :color="form.qualquerDistancia ? 'success' : ''"
                  @change="setDefaultDistance"
                >
                </v-switch>
              </v-col>
              <v-col>
                <c-input
                  :label="'Distancia KM'"
                  :placeholder="$t('placeholders.digite', { campo: 'KM' })"
                  type="number"
                  :maxLength="3"
                  :step="10"
                  :max="9999"
                  :min="-1"
                  v-model="form.distancia"
                  @input="updateDistance"
                />
                <c-input
                  :label="'Tempo Entrega'"
                  :placeholder="$t('placeholders.digite', { campo: 'minutos' })"
                  type="number"
                  :maxLength="3"
                  :step="5"
                  :max="999"
                  :min="-1"
                  v-model="form.tempoMinutos"
                />
                <c-input-money
                  v-model="form.valor"
                  :label="`${$t('labels.itemDelivery')}`"
                  :placeholder="`${$t('labels.itemDelivery')}`"
                  :class="''"
                  dark
                  dense
                  outlined
                  reverse
                  v-bind:valueWhenIsEmpty="'0'"
                  v-bind:options="{
                    locale: 'pt-BR',
                    prefix: '',
                    suffix: system.CIFRAO0,
                    length: 11,
                    precision: getPrecision(),
                  }"
                />
                <c-input-money
                  v-model="form.valorMinimoCompra"
                  :label="`${$t('labels.valorMinimo')} Compra`"
                  :placeholder="`${$t('labels.valorMinimo')} Compra`"
                  :class="''"
                  dark
                  dense
                  outlined
                  reverse
                  v-bind:valueWhenIsEmpty="'0'"
                  v-bind:options="{
                    locale: 'pt-BR',
                    prefix: '',
                    suffix: system.CIFRAO0,
                    length: 11,
                    precision: getPrecision(),
                  }"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <form-buttons @submitForm="submitForm()" @goBack="goBack()" />
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { mapActions, mapGetters } from 'vuex'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import cInputMoney from '@/components/shared/base-input/BaseInputMoney.vue'

export default {
  mixins: [formRegisterMixin, currencyMixin],

  components: {
    'megabit-base-dialog': BaseDialog,
    cInput,
    cInputMoney,
    FormButtons,
  },
  data: () => ({
    isLoading: true,
    form: {
      codigo: '',
      descricao: '',
      distancia: 1,
      valor: 0,
      valorTaxaMinima: 0,
      isExterior: false,
      qualquerDistancia: false,
    },
  }),
  computed:{
    ...mapGetters({
      system: 'systemModule/getCurrentSystem'
    })
  },
  methods: {
    ...mapActions({
      insert: 'deliveryFeeModule/insertDeliveryFee',
      update: 'deliveryFeeModule/updateDeliveryFee',
      getDeliveryFee: 'deliveryFeeModule/getDeliveryFee',
    }),

    async updateDistance(value) {
      console.log(value >= 0)
      this.form.distancia = parseInt(value) < 0 ? -1 : value
      this.form.qualquerDistancia = value < 0
      await this.$nextTick()
    },
    setDefaultDistance() {
      this.form.distancia =
        this.form.isExterior || this.form.qualquerDistancia
          ? -1
          : this.form.distancia
    },
    getPrecision() {
      let isGuarani = this.getCurrencies[0].cifrao.toLowerCase() == 'g$'
      return !isGuarani ? 2 : ''
    },

    async setData() {
      try {
        if (this.$route.params && this.$route.params.id > 0) {
          let delivery = await this.getDeliveryFee(this.$route.params.id)
          this.form = {
            ...delivery,
          }
          this.isUpdate = !this.isUpdate
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.isLoading = !this.isLoading
      }
    },
  },
  mounted() {
    this.setData()
  },
}
</script>
